<div mat-dialog-title style="float: right; margin: 0;">
  <button mat-raised-button color="warn" (click)="close()" matTooltip="Close the automation process">
    <mat-icon>close</mat-icon>
  </button>
</div>

<iframe [src]="frontend_url | safeIframe" style="width: 100%; height: calc(100% - 50px);" frameborder="0"></iframe>
